export class ButtonBinding {
  /** The text to display in the button. */
  public content = "@";

  /** true/false Disables button when set to true.*/
  public isDisabled = "<?";

  /** true/false Set to true to designate as a form submit button. */
  public isTypeSubmit = "<?";

  /** The accessibility label for this button, the value defaults to the content if not provided */
  public ariaLabel = "@?";

  /** The business intelligence (BI) behavior for this component. Valid values are the enumeration names found in ServiceDesk.Services.PageActionBehavior enumeraiton.*/
  public biBehavior = "@?";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";

  /** The title to appear on the button */
  public title = "@";

  /** Click handler for the button to use internally, respects button state (e.g. isDisabled) before invocation. */
  public onClick = "&?";

  public scenario = "<?";

  public scenarioStep = "<?";

  public telemetryData = "<?";

  /** true/false Set to true to designate type as button.*/
  public isTypeButton = "<?";
}

export class ButtonController {
  public content: string;
  public isDisabled: boolean;
  public isTypeSubmit: boolean;
  public isTypeButton: boolean;
  public buttonType: string = undefined;
  public ariaLabel: string;
  public biId: string;
  public title: string;
  public isInternallyDisabled: boolean;
  public onClick: (data: { $event: ng.IAngularEvent }) => void;
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery) {}

  $onInit() {
    this.refreshView();
  }

  $onChanges(changedObj: any) {
    this.refreshView();
  }

  public whenClicked($event: ng.IAngularEvent) {
    if (this.onClick && !this.isDisabled && !this.isInternallyDisabled) {
      this.onClick({ $event: $event });
    }
  }

  private refreshView(): void {
    if (this.isTypeSubmit) {
      this.buttonType = "Submit";
    }
    if (this.isTypeButton) {
      this.buttonType = "button";
    }
    if (this.isDisabled) {
      this.$element.attr("disabled", "disabled");
    } else {
      this.$element.removeAttr("disabled");
    }
  }

  public setInternallyDisabled(isDisabled: boolean): void {
    this.isInternallyDisabled = isDisabled;
  }
}
export const sdButton: ng.IComponentOptions = {
  bindings: <any>new ButtonBinding(),
  controller: ButtonController,
  templateUrl: "../ShellCommon/Controls/Button/Button.html",
  transclude: true
};
